/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlatformAnalyticsSummary
 */
export interface PlatformAnalyticsSummary {
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsSummary
     */
    totalImpressions: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsSummary
     */
    totalClicks: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsSummary
     */
    totalCompletions: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsSummary
     */
    totalParticipations: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsSummary
     */
    totalClaims: number;
    /**
     * Approximate unique users (nightly HLL snapshot, not time-filtered)
     * @type {number}
     * @memberof PlatformAnalyticsSummary
     */
    totalUniqueUsers: number;
}

/**
 * Check if a given object implements the PlatformAnalyticsSummary interface.
 */
export function instanceOfPlatformAnalyticsSummary(value: object): value is PlatformAnalyticsSummary {
    if (!('totalImpressions' in value) || value['totalImpressions'] === undefined) return false;
    if (!('totalClicks' in value) || value['totalClicks'] === undefined) return false;
    if (!('totalCompletions' in value) || value['totalCompletions'] === undefined) return false;
    if (!('totalParticipations' in value) || value['totalParticipations'] === undefined) return false;
    if (!('totalClaims' in value) || value['totalClaims'] === undefined) return false;
    if (!('totalUniqueUsers' in value) || value['totalUniqueUsers'] === undefined) return false;
    return true;
}

export function PlatformAnalyticsSummaryFromJSON(json: any): PlatformAnalyticsSummary {
    return PlatformAnalyticsSummaryFromJSONTyped(json, false);
}

export function PlatformAnalyticsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformAnalyticsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalImpressions': json['totalImpressions'],
        'totalClicks': json['totalClicks'],
        'totalCompletions': json['totalCompletions'],
        'totalParticipations': json['totalParticipations'],
        'totalClaims': json['totalClaims'],
        'totalUniqueUsers': json['totalUniqueUsers'],
    };
}

export function PlatformAnalyticsSummaryToJSON(json: any): PlatformAnalyticsSummary {
    return PlatformAnalyticsSummaryToJSONTyped(json, false);
}

export function PlatformAnalyticsSummaryToJSONTyped(value?: PlatformAnalyticsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalImpressions': value['totalImpressions'],
        'totalClicks': value['totalClicks'],
        'totalCompletions': value['totalCompletions'],
        'totalParticipations': value['totalParticipations'],
        'totalClaims': value['totalClaims'],
        'totalUniqueUsers': value['totalUniqueUsers'],
    };
}

